import { dayjs } from '@2wunder/klarx-tool'
import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { normalizeAddressSummary } from 'app/lib/apollo/normalizers/Rental'
import { ToolBox } from 'app/lib/hooks/toolBox'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  ref: React.Ref<HTMLDivElement>
}

const RequestText: React.FC<MemberProps<IRental, Props>> = ({ member, props: { ref } }) => {
  const { tRecordType, tAttribute } = ToolBox.useString()
  const { tComponent } = useTranslation({
    recordType: RecordType.copy_request,
    scope: 'modal.content',
    componentType: 'feedback'
  })
  const products = member.products || []
  const convertDates = (dateString: string) => {
    return dateString ? dayjs(dateString).toLocaleDate() : '-'
  }
  const dates = tAttribute({ recordType: RecordType.rental, attribute: 'dates' })
  const address = normalizeAddressSummary(member.deliveryAddress)

  const renderMachine = (lineItem: ILineItem) => {
    const subItems = (lineItem.subItems || []).filter((item) => item.lineItemType === 'product')
    return (
      <li key={lineItem.id}>
        <strong>{lineItem.name}</strong>
        <br />
        {dates}: {convertDates(lineItem.startDate)} - {convertDates(lineItem.returnDate)}
        <If condition={subItems && subItems.length > 0}>
          <ul>{subItems.map((subItem: ISubItem) => renderMachine(subItem))}</ul>
        </If>
      </li>
    )
  }

  return (
    <Row>
      <KCol className="text-primary mb-2">{tComponent({ id: 'label' })}</KCol>
      <KCol card span={24} cardProps={{ bordered: true }}>
        <div ref={ref} className="text-muted">
          <span>
            {tComponent({ id: 'initial_text' })}
            <br />
            <br />
          </span>
          <span>
            {tComponent({ id: 'delivery_address' }, { address })}
            <br />
            {dates}: {convertDates(member.startDate)} - {convertDates(member.returnDate)}
            <br />
            <br />
          </span>
          {tRecordType(RecordType.line_item, 'list_title')}:
          <ul>{products.map((product) => renderMachine(product))}</ul>
        </div>
      </KCol>
    </Row>
  )
}

export default RequestText
